<template>
  <div class="return-box">
    <slot></slot>
    <t-button @click="returnLast()">返回</t-button>
  </div>
</template>

<script>

import TButton from "@/components/el/t-button.vue";

export default {
  name: "return-box",
  components: {TButton},
  data() {
    return {}
  },
  mixins: [tableBase],
  methods: {},
  mounted() {

  }
}
</script>


<style lang="less" scoped>
.return-box{
  background: #ffffff;
  padding: 10px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-end;
}
</style>
